import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo FIDO 驗證輪詢
 */
const FidoAuthenticate = [
    'POST',
    RouteUrlList.API_FidoAuthenticate.path,
    {},
    200,
    {
        status: false,
        title: null,
        message: null,
        errorCode: null
    }
];

export default FidoAuthenticate;
